import React from "react";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { showToast } from "Source/globalFunction";

import Checkbox from "Components/common/Checkbox/Checkbox";
import DateInput from "Components/common/Functions/DatePicker/DateInput/DateInput";

class DateRange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPicker: null,
        }
    }

    render() {
        const dateRangeColumn = this.props.filterSelected && this.props.filterSelected.filter(f => f.id === "dateRange").length > 0 ? this.props.filterSelected[0] : {};

        const isFromGreaterThanTo = (date, section) => {
            return section === "from" && (dateRangeColumn.value || {}).to && Moment(Moment((dateRangeColumn.value || {}).to,"DD-MMM YYYY").format()).isBefore(Moment(date,"DD-MMM YYYY").format());
        }

        const isToGreaterThanFrom = (date, section) => {
            return section === "to" && (dateRangeColumn.value || {}).from && Moment(Moment((dateRangeColumn.value || {}).from,"DD-MMM YYYY").format()).isAfter(Moment(date,"DD-MMM YYYY").format());
        }

        const setSelectedPicker = (value) => {
            if(this.state.selectedPicker === value) {
                this.setState({...this.state, selectedPicker: null});
            } else {
                this.setState({...this.state, selectedPicker: value});
            }
        }

        const onSelectDate = (date, section) => {
            if(isToGreaterThanFrom(date)) {
                showToast("error", "Period to must be after the Period from date.");
            } else if(isFromGreaterThanTo(date)) {
                showToast("error", "Period from must be after the Period to date.");
            } else {
                this.props.onUpdate(this.props.filterSelected.map(f => {
                    if(f.id === "dateRange") {
                        return {
                            ...f,
                            value: {
                                ...(f.value || {}),
                                [section]: date ? Moment(date).format("DD-MMM YYYY") : null
                            }
                        }
                    }

                    return f;
                }));
            }
        }

        const handleInputChange = (date, section) => {
            if(isFromGreaterThanTo(date, section)) {
                showToast("error", "Period from must be after the Period to date.");
            } else {
                onSelectDate(date, section);
            }
        }

        const handleInputBlur = (date, section) => {
            if(date) {
                if(isToGreaterThanFrom(date, section) || isFromGreaterThanTo(date, section)) {
                    onSelectDate(null, section);
                }
            } else {
                onSelectDate(null, section);
            }
        }

        return (
            <div class="dateRangeContainer">
                <div class="filterCheckbox">
                    <Checkbox checked={!this.props.isChecked} onChange={this.props.onSelect} value={this.props.filter.id} />
                    <span>Date Range</span>
                </div>
                {!this.props.isChecked &&
                    <div class="filterOption">
                        <div class="pickerFields">
                            <div class="pickerFieldContainer">
                                <DateInput
                                    value={((dateRangeColumn.value || {}).from || "")} 
                                    onChange={e => handleInputChange(e, "from")}
                                    onBlur={e => handleInputBlur(e, "from")}
                                />
                                <a onClick={() => setSelectedPicker("from")}>
                                    <i class={`material-icons ${((dateRangeColumn.value || {}).from ? "hasValue" : "")}`}>calendar_today</i>
                                </a>
                            </div>
                            <span>to</span> 
                            <div class="pickerFieldContainer">
                                <DateInput
                                    value={((dateRangeColumn.value || {}).to || "")} 
                                    onChange={e => handleInputChange(e, "to")}
                                    onBlur={e => handleInputBlur(e, "to")}
                                />
                                <a onClick={() => setSelectedPicker("to")}>
                                    <i class={`material-icons ${((dateRangeColumn.value || {}).to ? "hasValue" : "")}`}>calendar_today</i>
                                </a>
                            </div>
                        </div>
                        {this.state.selectedPicker && (
                            <div class="pickerContainer">
                                <DatePicker 
                                    dateFormat="DD-MMM YYYY"
                                    inline
                                    useWeekdaysShort={true}
                                    shouldCloseOnSelect={false}
                                    selected={(dateRangeColumn.value || {})[this.state.selectedPicker] ? Moment((dateRangeColumn.value || {})[this.state.selectedPicker]).toDate() : null}
                                    onChange={date => onSelectDate(date, this.state.selectedPicker)}
                                    minDate={this.state.selectedPicker === "to" ? (dateRangeColumn.value && dateRangeColumn.value.from ? Moment(dateRangeColumn.value.from).toDate() : null) : null}
                                />
                            </div>
                        )}
                    </div>
                }
            </div>
        )
    }
}

export default DateRange;